import module from '../bahabot.module'

module.filter('bbTextBool', () => {
    return function(input) {
        return input ? 'Yes' : 'No';
    };
})